<template>
  <div class="w-full">
    <Panel header="Chi tiết văn bản">

      <div class="grid grid-cols-12 gap-4">

        <!-- Thông tin -->
        <div class="col-span-12">
          <div
              class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div class="mb-3">
              <div class="text-2xl font-bold text-slate-900">
                {{ documentObject.title }}
              </div>
            </div>

            <div class="flex flex-wrap gap-6 text-sm text-slate-500">
              <div>
                <i class="pi pi-user mr-2"></i>
                {{ documentObject.sender }}
              </div>

              <div>
                <i class="pi pi-clock mr-2"></i>
                {{ formatDateTime(documentObject.time) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Nội dung -->
        <div class="col-span-12">
          <div
              class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
                class="mb-3 text-lg font-bold text-slate-900"
            >
              Nội dung
            </div>

            <div
                class="whitespace-pre-wrap leading-7"
            >
              {{ documentObject.content }}
            </div>
          </div>
        </div>

        <!-- Danh sách file -->
        <div class="col-span-12">
          <div
              class="rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
                class="border-b border-slate-200 bg-slate-50 px-3 py-2"
            >
              <div
                  class="text-sm font-semibold text-slate-700"
              >
                Tài liệu đính kèm
              </div>
            </div>

            <div class="p-3">

              <div
                  v-if="documentObject.listAttachments?.length"
              >

                <div
                    v-for="item in documentObject.listAttachments"
                    :key="item.id"
                    class="attachment-item"
                >

                  <div class="attachment-name">
                    <i
                        class="pi pi-file-pdf text-red-500 mr-2"
                    ></i>

                    {{ item.fileName }}
                  </div>

                  <div class="attachment-actions">

                    <Button
                        size="small"
                        icon="pi pi-eye"
                        label="Xem"
                        @click="viewPdf(item)"
                    />

                    <Button
                        size="small"
                        icon="pi pi-download"
                        label="Tải"
                        severity="secondary"
                        @click="downloadFile(item)"
                    />

                  </div>

                </div>

              </div>

              <div
                  v-else
                  class="py-4 text-center text-slate-500"
              >
                Không có tài liệu đính kèm
              </div>

            </div>
          </div>
        </div>

      </div>

    </Panel>

    <!-- Dialog xem PDF -->
    <Dialog
        v-model:visible="showPdfDialog"
        modal
        maximizable
        :style="{ width: '100vw' }"
        :breakpoints="{ '960px': '100vw' }"
        :header="selectedAttachment?.fileName || 'Xem tài liệu'"
    >

      <iframe
          v-if="selectedPdf"
          :src="selectedPdf"
          width="100%"
          height="850"
          frameborder="0"
      />

    </Dialog>

  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import zaloRepository from "@/services/ZaloRepository";
import {DocumentDetail} from "@/models/documentDetail";
import moment from "moment";

export default defineComponent({
  name: "ViewDocument",

  components: {

  },

  setup() {

    const selectedPdf = ref("");

    const selectedAttachment = ref<any>(null);

    const showPdfDialog = ref(false);

    const documentObject = ref({} as DocumentDetail);

    const formatDateTime = (date: any) => {
      return moment(String(date))
          .format("DD/MM/YYYY");
    };

    const viewPdf = (attachment: any) => {

      selectedAttachment.value = attachment;

      selectedPdf.value =
          `${window.location.origin}/${attachment.link}`;

      showPdfDialog.value = true;
    };

    const downloadFile = (attachment: any) => {

      const link =
          document.createElement("a");

      link.href =
          `${window.location.origin}/${attachment.link}`;

      link.download =
          attachment.fileName;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    };

    onMounted(async () => {

      try {

        const response =
            await zaloRepository.getDocumentDetail(
                9
            );

        documentObject.value =
            response.data;

      } catch (e) {

        console.error(e);
      }
    });

    return {
      documentObject,
      selectedPdf,
      selectedAttachment,
      showPdfDialog,
      viewPdf,
      downloadFile,
      formatDateTime
    };
  }
});
</script>

<style scoped>

iframe {
  border: none;
}

.attachment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 12px;

  padding: 8px 12px;

  margin-bottom: 6px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.attachment-item:hover {
  background: #f8fafc;
}

.attachment-name {
  flex: 1;

  display: flex;
  align-items: flex-start;

  font-size: 13px;

  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;

  line-height: 1.3;
}

.attachment-actions {
  white-space: nowrap;
}

:deep(.p-dialog-content) {
  padding: 0;
}
.attachment-actions {
  display: flex;
  align-items: center;
  gap: 10px; /* khoảng cách giữa các nút */
  flex-shrink: 0;
}
</style>